import { render, staticRenderFns } from "./Schemas.vue?vue&type=template&id=7cde818f"
import script from "./Schemas.vue?vue&type=script&lang=js"
export * from "./Schemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports